<template>
  <div class="page-loader">
    <div class="page-loader__spinner">
      <svg viewBox="25 25 50 50">
        <circle cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"/>
      </svg>
    </div>
  </div>
</template>
<script>
  export default {
    mounted() {
      const pageLoader = document.getElementsByClassName('page-loader')[0];
      pageLoader.classList.add('animated');
      pageLoader.classList.add('fadeOut');
      setTimeout(() => {
        pageLoader.style.display = 'none';
      }, 200);
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/app-loading.vue